import React from "react";
import warning from "../shares/warning.png";

const ResetModal = ({
  isOpen,
  onConfirm,
  title,
  subtitle,
  btn_text = "Logout",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
      <div className="login-container bg-white flex flex-col rounded-lg shadow-lg max-w-sm w-full">
      <div className="bg-[#B90000] text-xl text-center text-white font-normal py-2 rounded-t-lg">
          {title}
        </div>
        <div className="flex px-6 mt-4">
          <img
            src={warning}
            className="h-16 w-16 mt-1"
          ></img>
          <p className="text-sm ml-4 mb-4 text-justify" style={{fontFamily: "'DM Sans', sans-serif", fontSize: "15px"}}>{subtitle}</p>
        </div>
        <div className="flex justify-end gap-2 mr-4 pb-4">
            <button
              onClick={onConfirm}
              className="bg-[#528DCA] text-white px-4 py-2 rounded-xl hover:bg-blue-600"
            >
              {btn_text}
            </button>
          </div>
      </div>
    </div>
  );
};

export default ResetModal;
